import { Navigate } from "react-router-dom";
import WayaOfficialRouteGuard from "@/guards/waya-official-route-guard";
import WayaOfficialOutlet from "./waya-official-outlet";
import WayaOfficial from "./WayaOfficial";
import PayoutRoutes from "./payout/payout-routes";
import SettlementPage from "./settlement/settlement-page";
import TransactionPage from "./transactions/transaction-page";
import LedgerOutlet from "../ledger/pages/ledger-outlet";
import LedgerAccounts from "../ledger/pages/ledger-account";
import LedgerAccountDetail from "../ledger/pages/ledger-account-details";
import CollectionPage from "./collections/collection-page";

const WayaOfficialRoutes = [
  {
    path: "/waya-official",
    element: (
      <WayaOfficialRouteGuard>
        <WayaOfficialOutlet />
      </WayaOfficialRouteGuard>
    ),
    children: [
      {
        element: <WayaOfficial />,
        children: [
          { index: true, element: <Navigate to="payout" replace /> },
          ...PayoutRoutes,
          { path: "settlement", element: <SettlementPage /> },
          { path: "transaction", element: <TransactionPage /> },
          { path: "collection", element: <CollectionPage /> },
          {
            path: "ledger",
            element: <LedgerOutlet />,
            children: [
              { index: true, element: <Navigate to="accounts" replace /> },
              { path: "accounts", element: <LedgerAccounts /> },
              { path: "accounts/:accountNumber", element: <LedgerAccountDetail /> },
            ],
          },
        ],
      },
    ],
  },
];

export default WayaOfficialRoutes;
